import { render, staticRenderFns } from "./AtaDirexDadosCadastrais.vue?vue&type=template&id=4ede9559"
import script from "./AtaDirexDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./AtaDirexDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports